import { MassActionsActionTypes, MassActionsState, MASS_ACTIONS_FAILURE, MASS_ACTIONS_REQUEST, MASS_ACTIONS_SUCCESS } from './types';

const defaultState: MassActionsState = {
  isLoading: false,
  errorMessage: '',
  contents: [],
};

export default function massActions(state = defaultState, action: MassActionsActionTypes): MassActionsState {
  switch (action.type) {
    case MASS_ACTIONS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case MASS_ACTIONS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ''
      };
    case MASS_ACTIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ''
      };
    default:
      return state;
  }
};